import { default as tunnelRat } from 'tunnel-rat'

export const tunnel = tunnelRat()
